import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, bool } from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import { textFormat } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";
import InputLabel from "@material-ui/core/InputLabel";

const style = () => ({
  selectInput: {
    "& .MuiSelect-root": {
      padding: "10px",
      textAlign:"left",
    },
    "& .MuiFormLabel-root": {
      fontSize: "0.875rem",
      top: "-10px",
      left: "0.875rem",
      color: brandTheme.black,
    },
    "& .MuiInputBase-root.Mui-disabled":{
      backgroundColor: brandTheme.disabled,
     },
    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.black,
      top: "-7px",
      left: "14px",
      fontSize: "1rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
  },
  errorInput: {
    "& .MuiFormLabel-root": {
      color: brandTheme.errorColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.errorColor,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.errorColor,
    },
  },
});

const CustomSelectNew = ({
  label,
  id,
  required,
  classes,
  data,
  value,
  setState,
  setError,
  error,
  type,
  setCharge,
  index,
  disabled
}) => {
  return (
    <FormControl
      fullWidth
      className={
        error
          ? `${classes.errorInput} ${classes.selectInput}`
          : classes.selectInput
      }
    >
      <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel>
      <Select
        size="small"
        required={required}
        variant="outlined"
        labelId="demo-simple-select-filled-label"
        id={id}
        value={value}
        label={label}
        disabled={disabled}
        onChange={(event) => {
          if(setCharge){
            setCharge(index, type, event.target.value)
          }else{
          setState(event.target.value);
          // setError(false);
          }
        }}
      >
        {data &&
          data?.map((item, index) => {
           const eployeeIdName = `${item?.employeeId}-${item?.name}`;
            let selectValue = "";
            switch (type) {
              case "channel":
                selectValue = item?.channel;
                break;
                case "name":
                  selectValue = item?.name;
                  break;
                  case "loan":
                  selectValue = textFormat(item?.code);
                  break;
                  case "type":
                  selectValue = item?.code;
                  break;
                  case "branch":
                  selectValue = item?.branchCode;
                  break;
                  case "relationshipname":
                    selectValue = item?.relationshipName;
                    break
                  case "referalName":
                    selectValue = item?.employeeId ? eployeeIdName :  `${item?.name}`;
                    break;
                  case "displayName":
                    selectValue = item?.value;
                    break;
                  case "packetNumber":
                    selectValue = item?.value;
                    break;
                    case "loanAccountNumbers":
                      selectValue = item?.loanAccountNumber;
                      break;
                  case "decision":
                    selectValue = item;
                    break;
              default:
                selectValue = item;
            }

            let selectName = "";
            switch (type) {
              case "channel":
                selectName = item?.channel;
                break;
                case "scheme":
                  selectName = item?.schemeName;
                  break;
                  case "name":
                    selectName = item?.name;
                    break;
                    case "loan":
                      selectName = textFormat(item?.name);
                      break;
                      case "relationshipname":
                        selectName = item?.relationshipName;
                        break
                    case "type":
                      selectName = item?.name;
                      break;
                    case "branch":
                      selectName = item?.branchName;
                      break;
                      case "referalName":
                        selectName =  item?.employeeId ? eployeeIdName :  `${item?.name}`;
                        break;
                        case "displayName":
                          selectName = item?.displayName;
                    break;
                    case "loanAccountNumbers":
                      selectName = item?.loanAccountNumber;
                      break;
                    case "packetNumber":
                    selectName = item?.value;
                    break;
                        case "decision":
                          selectName = removeUnderscores(item);
                    break;
              default:
                selectName = item;
            }
            return (
              <MenuItem key={index} value={selectValue} disabled={item?.disabled}>
                {selectName}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

CustomSelectNew.propTypes = {
  label: string,
  id: string,
  required: bool,
};
CustomSelectNew.defaultProps = {
  label: "",
  id: "text-field",
  required: false,
};
export default withStyles(style)(CustomSelectNew);